import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/skarb.jpg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "guide-wrapper my-5" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://levelpro.com/mundial-skarb-ms/" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "guide-image",
      src: _imports_0
    })
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://levelpro.com/mundial-skarb-ms/",
    class: "btn btn-blue btn-guide my-1"
  }, "Pobierz")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Hero = _resolveComponent("Hero")!
  const _component_GuideTitle = _resolveComponent("GuideTitle")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header),
    _createVNode(_component_Hero, {
      team1: _ctx.game.team1,
      team2: _ctx.game.team2,
      game: _ctx.game
    }, null, 8, ["team1", "team2", "game"]),
    _createVNode(_component_GuideTitle),
    _hoisted_1
  ]))
}